import { type FC } from 'react';

export type ThrowErrorProps = {
  /**
   * The error to throw.
   */
  error: Error;
};

/**
 * A React component that throws an error when rendered.
 * This is useful for testing and using error boundaries.
 */
export const ThrowError: FC<ThrowErrorProps> = ({ error }) => {
  throw error;
};
